var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationHelpdesk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.894 59.447l-1.789-.894c.132-.263 3.282-6.45 8.699-7.533l6.848-1.96C31.776 48.538 33 47.579 33 47v-5h2v5c0 2.193-2.992 3.644-3.591 3.913a1.347 1.347 0 01-.134.049l-7 2c-4.548.912-7.353 6.43-7.381 6.485M63.106 59.448c-.028-.055-2.851-5.577-7.302-6.468l-7.079-2.018a1.347 1.347 0 01-.134-.049C47.992 50.644 45 49.193 45 47v-5h2v5c0 .636 1.365 1.604 2.346 2.059l6.929 1.979c5.338 1.065 8.488 7.252 8.62 7.515l-1.789.895",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 23.618V25a1 1 0 01-1 1c-1.103 0-2 .897-2 2v3c0 6.261 2.503 13 8 13s8-6.739 8-13v-3c0-1.103-.897-2-2-2h-6c-.155 0-.309-.036-.447-.105L35 23.618zM40 46c-6.871 0-10-7.775-10-15v-3a4.006 4.006 0 013-3.873V22c0-.347.18-.668.474-.851.295-.182.663-.198.973-.044L40.236 24H46c2.206 0 4 1.794 4 4v3c0 7.225-3.129 15-10 15zM42 55h-4a.997.997 0 01-.707-.293L33.586 51H31v-2h3a1 1 0 01.707.293L38.414 53h3.172l3.707-3.707A.997.997 0 0146 49h3v2h-2.586l-3.707 3.707A.997.997 0 0142 55",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M39 64h2v-2h-2zM39 60h2v-2h-2zM39 68h2v-2h-2zM45 62h8v-2h-8z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 26h-2v-1c0-4.625-3.506-8.445-8-8.944V17a1 1 0 01-1.316.948l-5.842-1.947C31.952 16.086 28 20.09 28 25v1h-2v-1c0-6.065 4.935-11 11-11 .107 0 .214.018.316.052L42 15.612V15a1 1 0 011-1c6.065 0 11 4.935 11 11v1",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 38c-3.86 0-7-3.141-7-7s3.14-7 7-7v2c-2.757 0-5 2.243-5 5s2.243 5 5 5v2M50 38v-2c2.757 0 5-2.243 5-5s-2.243-5-5-5v-2c3.86 0 7 3.141 7 7s-3.14 7-7 7",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 42H41c-1.654 0-3-1.346-3-3h2c0 .552.449 1 1 1h11c.551 0 1-.448 1-1v-4h2v4c0 1.654-1.346 3-3 3",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 10c-16.542 0-30 13.458-30 30s13.458 30 30 30 30-13.458 30-30-13.458-30-30-30zm0 62C22.355 72 8 57.645 8 40S22.355 8 40 8s32 14.355 32 32-14.355 32-32 32z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }))));
}

export default SvgIconIllustrationHelpdesk;